export default "__VITE_ASSET__CluOHdRh__";